import React from 'react';

import { Typography } from '@mui/material';

const ErrorMessage = ({ hasError }) => {
  if (!hasError) return null;
  return (
    <Typography variant="subtitle2" color="error">
      Complete todos los campos para realizar la búsqueda
    </Typography>
  );
};

export default ErrorMessage;
